module.exports = __webpack_public_path__ + "img/road4.f4e578e0.jpg";